import { httpDomainServiceApim } from "../../utils/domainServiceAPIMConfig";
import { ICrewType } from "../../model/domainServices/ICrewType";
import { IArrayOption } from "../../model/IArrayOption";
import { IPaginationResult } from "../../model/search/IPaginationResult";
import { ISearch } from "../../model/search/ISearch";

//Search
const getSearch = async (objISearch: ISearch, strToken: string = "") => {
    const params = JSON.stringify({
        search: objISearch.search,
        sortBy: objISearch.sortBy,
        sortOrder: objISearch.sortOrder,
        filterBy: {
            columnName: objISearch.filterBy?.columnName,
            columnValue: objISearch.filterBy?.columnValue,
        },
        paginationInfo: {
            perPage: objISearch.pagination?.perPage,
            page: objISearch.pagination?.page,
        },
    });

    const data = await httpDomainServiceApim.post<IPaginationResult<ICrewType>>(
        "/crew_types/get",
        params,
        {
            headers: {
                Authorization: `Bearer ${strToken}`,
            },
        },
    );

    return data;
};

const getById = async (id: string, strToken: string = "") => {
    const data = await httpDomainServiceApim.post<ICrewType>(
        `/crew_types/get/${id}`,
        "",
        {
            headers: {
                Authorization: `Bearer ${strToken}`,
            },
        },
    );
    return data;
};

export const CrewTypeService = {
    getSearch,
    getById,
};

export const getCrewType = (
    crewTypeStateResult: IPaginationResult<ICrewType>,
    crewTypeId: string,
) => {
    if (crewTypeStateResult != null) {
        const result = crewTypeStateResult.data.find(
            (value) => value.crewTypeId === crewTypeId,
        );
        return result;
    } else {
        return undefined;
    }
};

export const bindCrewTypeDropdown = (
    crewTypePaginationResult: IPaginationResult<ICrewType>,
): IArrayOption[] => {
    const options = [];

    const empty: IArrayOption = { label: "--Select--", value: null };
    options.push(empty);

    if (crewTypePaginationResult.data) {
        for (let i = 0; i < crewTypePaginationResult.data.length; i++) {
            let obj: IArrayOption = {
                label:
                    crewTypePaginationResult.data[i].code +
                    " - " +
                    crewTypePaginationResult.data[i].description,
                value: crewTypePaginationResult.data[i].crewTypeId,
            };
            options.push(obj);
        }
    }

    return options;
};
export const convertCrewTypesToArrayOptions = (
    data: ICrewType[],
): IArrayOption[] => {
    const options = [];

    const empty: IArrayOption = { label: "--Select--", value: null };
    options.push(empty);

    if (data) {
        for (let i = 0; i < data.length; i++) {
            let obj: IArrayOption = {
                label: data[i].code + " - " + data[i].description,
                value: data[i].crewTypeId,
            };
            options.push(obj);
        }
    }

    return options;
};
